import './App.css';
import { Spinner, Toast } from './ui-elements';
import { Toaster } from './components/Shadcn/Sonner';
import Router from './Router';

function App() {
	return (
		<div className="h-100">
			<Spinner />
			<Toast />
			<Toaster />
			{/* <BrowserRouter> */}
				<Router />
			{/* </BrowserRouter> */}
		</div>
	);
}

export default App;
